import jwt from 'jsonwebtoken';
import moment from 'moment';
import { JWTToken, RefreshToken, TokenDecoded } from './UserService.interface';

export type TokenType = 'access-token' | 'refresh-token';

const PREFIX = process.env.REACT_APP_LOCAL_STORAGE_PREFIX;

export interface IAuthService {
  isAuthenticated(): boolean;
  getToken(tokenType: TokenType): JWTToken | RefreshToken;
  setToken(tokenType: TokenType, token: JWTToken | RefreshToken): void;
  removeToken(tokenType: TokenType): void;
}

export class AuthService implements IAuthService {
  public static accessTokenName = `${PREFIX}-access-token`;
  public static refreshTokenName = `${PREFIX}-refresh-token`;

  public accessToken: JWTToken;
  public refreshToken: RefreshToken;

  constructor() {
    this.accessToken = this.getToken('access-token');
    this.refreshToken = this.getToken('refresh-token');
  }

  private getTokenName(tokenType: TokenType): string {
    return tokenType === 'access-token'
      ? AuthService.accessTokenName
      : AuthService.refreshTokenName;
  }

  isAuthenticated(): boolean {
    //check session is expire
    return this.getToken('access-token') !== null;
  }

  getToken(tokenType: TokenType): string {
    const tokenName: string = this.getTokenName(tokenType);
    const token = localStorage.getItem(tokenName);
    return token || '';
  }

  shouldRefreshToken(): boolean {
    const _token = this.getToken('access-token');

    if (_token) {
      const token = _token.replace('Bearer ', '');
      const decoded = jwt.decode(token) as TokenDecoded;

      const currentDate = moment();
      const tokenExpiredAt = moment.unix(decoded.exp);

      const tokenExpiredAtMinute = tokenExpiredAt.diff(currentDate, 'minute');
      const isTokenExpiredLessThanTenMinute = tokenExpiredAtMinute < 10;

      return isTokenExpiredLessThanTenMinute;
    }

    return false;
  }

  setToken(tokenType: TokenType, token: string): void {
    const d = new Date();
    d.setTime(d.getTime() + 60 * 60 * 1000); // set cookie to last 60 mins
    const tokenName: string = this.getTokenName(tokenType);
    localStorage.setItem(
      tokenName,
      JSON.stringify({
        token: token,
        expires: d,
      }),
    );
  }

  removeToken(tokenType: TokenType): void {
    const tokenName: string = this.getTokenName(tokenType);
    localStorage.removeItem(tokenName);
  }
}
